import { render, staticRenderFns } from "./QuotaholdersTable.vue?vue&type=template&id=9329c7fc&"
import script from "./QuotaholdersTable.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports